import SegmentedControl from '@risk-smart/themed-cloudscape-components/segmented-control';
import type { FC } from 'react';

interface ChatModeProps {
  selectedMode: 'platform' | 'agent';
  onModeChange: (mode: 'platform' | 'agent') => void;
}

/**
 * Mode selector for the AI chat side panel — switches between the existing
 * platform-knowledge chat and the read-only RiskSmart Agent. The parent gates
 * rendering on the `ai.subModules.agent` entitlement; this component just owns
 * the control and narrows the cloudscape change event back to the mode union.
 */
export const ChatMode: FC<ChatModeProps> = ({ selectedMode, onModeChange }) => (
  <SegmentedControl
    selectedId={selectedMode}
    label={'Chat mode'}
    options={[
      { id: 'platform', text: 'Knowledge' },
      { id: 'agent', text: 'Agent' },
    ]}
    onChange={({ detail }) => {
      if (detail.selectedId === 'platform' || detail.selectedId === 'agent') {
        onModeChange(detail.selectedId);
      }
    }}
  />
);
